(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("BaklavaJSRendererVue", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["BaklavaJSRendererVue"] = factory(require("vue"));
	else
		root["BaklavaJSRendererVue"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 82);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __decorate; });
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __generator; });
/* unused harmony export __exportStar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __spread; });
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Provide; });
/* unused harmony export Model */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Prop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Watch; });
/* unused harmony export Emit */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "e", function() { return vue__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a; });
/** vue-property-decorator verson 8.1.0 MIT LICENSE copyright 2018 kaorun343 */
/// <reference types='reflect-metadata'/>




/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) || null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) && typeof options !== 'function' && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return Object(vue_class_component__WEBPACK_IMPORTED_MODULE_1__["createDecorator"])(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                if (returnValue !== undefined)
                    args.unshift(returnValue);
                _this.$emit.apply(_this, [event || key].concat(args));
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(function (returnValue) {
                    emit(returnValue);
                });
            }
            else {
                emit(returnValue);
            }
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObserverController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resizeObservers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return process; });
/* harmony import */ var _utils_scheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43);
/* harmony import */ var _ResizeObservation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73);
/* harmony import */ var _ResizeObserverDetail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var _algorithms_hasActiveObservations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75);
/* harmony import */ var _algorithms_hasSkippedObservations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76);
/* harmony import */ var _algorithms_deliverResizeLoopError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77);
/* harmony import */ var _algorithms_broadcastActiveObservations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78);
/* harmony import */ var _algorithms_gatherActiveObservationsAtDepth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50);








var resizeObservers = [];
var observerMap = new Map();
var watching = 0;
var updateCount = function (n) {
    !watching && n > 0 && _utils_scheduler__WEBPACK_IMPORTED_MODULE_0__[/* scheduler */ "a"].start();
    watching += n;
    !watching && _utils_scheduler__WEBPACK_IMPORTED_MODULE_0__[/* scheduler */ "a"].stop();
};
var getObservationIndex = function (observationTargets, target) {
    for (var i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
var process = function () {
    var depth = 0;
    Object(_algorithms_gatherActiveObservationsAtDepth__WEBPACK_IMPORTED_MODULE_7__[/* gatherActiveObservationsAtDepth */ "a"])(depth);
    while (Object(_algorithms_hasActiveObservations__WEBPACK_IMPORTED_MODULE_3__[/* hasActiveObservations */ "a"])()) {
        depth = Object(_algorithms_broadcastActiveObservations__WEBPACK_IMPORTED_MODULE_6__[/* broadcastActiveObservations */ "a"])();
        Object(_algorithms_gatherActiveObservationsAtDepth__WEBPACK_IMPORTED_MODULE_7__[/* gatherActiveObservationsAtDepth */ "a"])(depth);
    }
    if (Object(_algorithms_hasSkippedObservations__WEBPACK_IMPORTED_MODULE_4__[/* hasSkippedObservations */ "a"])()) {
        Object(_algorithms_deliverResizeLoopError__WEBPACK_IMPORTED_MODULE_5__[/* deliverResizeLoopError */ "a"])();
    }
    return depth > 0;
};
var ResizeObserverController = (function () {
    function ResizeObserverController() {
    }
    ResizeObserverController.connect = function (resizeObserver, callback) {
        var detail = new _ResizeObserverDetail__WEBPACK_IMPORTED_MODULE_2__[/* ResizeObserverDetail */ "a"](resizeObserver, callback);
        resizeObservers.push(detail);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function (resizeObserver, target, options) {
        if (observerMap.has(resizeObserver)) {
            var detail = observerMap.get(resizeObserver);
            if (getObservationIndex(detail.observationTargets, target) < 0) {
                detail.observationTargets.push(new _ResizeObservation__WEBPACK_IMPORTED_MODULE_1__[/* ResizeObservation */ "a"](target, options && options.box));
                updateCount(1);
                _utils_scheduler__WEBPACK_IMPORTED_MODULE_0__[/* scheduler */ "a"].schedule();
            }
        }
    };
    ResizeObserverController.unobserve = function (resizeObserver, target) {
        if (observerMap.has(resizeObserver)) {
            var detail = observerMap.get(resizeObserver);
            var index = getObservationIndex(detail.observationTargets, target);
            if (index >= 0) {
                detail.observationTargets.splice(index, 1);
                updateCount(-1);
            }
        }
    };
    ResizeObserverController.disconnect = function (resizeObserver) {
        if (observerMap.has(resizeObserver)) {
            var detail = observerMap.get(resizeObserver);
            resizeObservers.splice(resizeObservers.indexOf(detail), 1);
            observerMap.delete(resizeObserver);
            updateCount(-detail.observationTargets.length);
        }
    };
    return ResizeObserverController;
}());



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _connection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _connection__WEBPACK_IMPORTED_MODULE_0__["a"]; });




/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return global; });
var global = typeof window === 'undefined' ? undefined || {} : window;



/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateBoxSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateBoxSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cache; });
/* harmony import */ var _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);
/* harmony import */ var _DOMRectReadOnly__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49);
/* harmony import */ var _utils_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);




var cache = new Map();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = (/msie|trident/i).test(_utils_global__WEBPACK_IMPORTED_MODULE_3__[/* global */ "a"].navigator && _utils_global__WEBPACK_IMPORTED_MODULE_3__[/* global */ "a"].navigator.userAgent);
var parseDimension = function (pixel) { return parseFloat(pixel || '0'); };
var size = function (inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) { inlineSize = 0; }
    if (blockSize === void 0) { blockSize = 0; }
    if (switchSizes === void 0) { switchSizes = false; }
    return Object.freeze({
        inlineSize: (switchSizes ? blockSize : inlineSize) || 0,
        blockSize: (switchSizes ? inlineSize : blockSize) || 0
    });
};
var zeroBoxes = Object.freeze({
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new _DOMRectReadOnly__WEBPACK_IMPORTED_MODULE_1__[/* DOMRectReadOnly */ "a"](0, 0, 0, 0)
});
var calculateBoxSizes = function (target) {
    if (cache.has(target)) {
        return cache.get(target);
    }
    if (Object(_utils_element__WEBPACK_IMPORTED_MODULE_2__[/* isHidden */ "a"])(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = Object(_utils_element__WEBPACK_IMPORTED_MODULE_2__[/* isSVG */ "c"])(target) && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = Object.freeze({
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new _DOMRectReadOnly__WEBPACK_IMPORTED_MODULE_1__[/* DOMRectReadOnly */ "a"](paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function (target, observedBox) {
    var _a = calculateBoxSizes(target), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize;
    return observedBox === _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__[/* ResizeObserverBoxOptions */ "a"].BORDER_BOX ? borderBoxSize : contentBoxSize;
};



/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
  * vue-class-component v7.0.2
  * (c) 2015-present Evan You
  * @license MIT
  */


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__(6));

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return Vue.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (false) {}
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue
        ? superProto.constructor
        : Vue;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if (false) {}
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

exports.default = Component;
exports.createDecorator = createDecorator;
exports.mixins = mixins;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSVG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isReplacedElement; });
var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
var isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isReplacedElement = function (target) {
    switch (target.tagName) {
        case 'INPUT':
            if (target.type !== 'image') {
                break;
            }
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ConnectionView_vue_vue_type_template_id_34929434___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47);
/* harmony import */ var _ConnectionView_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _ConnectionView_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _ConnectionView_vue_vue_type_template_id_34929434___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _ConnectionView_vue_vue_type_template_id_34929434___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/connection/ConnectionView.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return POLYFILL_CONSOLE_OUTPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prettifyConsoleOutput; });
var POLYFILL_CONSOLE_OUTPUT = 'function ResizeObserver () { [polyfill code] }';
var prettifyConsoleOutput = function (fn) {
    Object.defineProperty(fn, 'toString', {
        value: function () { return POLYFILL_CONSOLE_OUTPUT; }
    });
    return fn;
};



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDomElements; });
function getDomElements(ni) {
    var nodeDOM = document.getElementById(ni.parent.id);
    var interfaceDOM = document.getElementById(ni.id);
    return {
        node: nodeDOM,
        interface: interfaceDOM
    };
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _eventEmitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _eventEmitter__WEBPACK_IMPORTED_MODULE_0__["a"]; });




/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Editor_vue_vue_type_template_id_e18b6dc6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44);
/* harmony import */ var _Editor_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _Editor_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _Editor_vue_vue_type_template_id_e18b6dc6___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _Editor_vue_vue_type_template_id_e18b6dc6___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/Editor.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70);
/* harmony import */ var _history__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71);





var EditorView = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](EditorView, _super);
    function EditorView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nodeeditor = _this;
        _this.temporaryConnection = null;
        _this.hoveringOver = null;
        _this.selectedNodes = [];
        _this.dragging = false;
        _this.ctrlPressed = false;
        _this.contextMenu = {
            items: [],
            show: false,
            x: 0,
            y: 0
        };
        return _this;
    }
    Object.defineProperty(EditorView.prototype, "styles", {
        get: function () {
            return {
                "transform-origin": "0 0",
                "transform": "scale(" + this.plugin.scaling + ") translate(" + this.plugin.panning.x + "px, " + this.plugin.panning.y + "px)"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorView.prototype, "nodes", {
        get: function () {
            return this.plugin.editor ? this.plugin.editor.nodes : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorView.prototype, "connections", {
        get: function () {
            return this.plugin.editor ? this.plugin.editor.connections : [];
        },
        enumerable: true,
        configurable: true
    });
    EditorView.prototype.mounted = function () {
        var _this = this;
        this.updateContextMenu();
        this.plugin.editor.events.registerNodeType.addListener(this, function () { return _this.updateContextMenu(); });
        this.clipboard = new _clipboard__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](this.plugin.editor);
        this.history = new _history__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](this.plugin);
    };
    EditorView.prototype.updateContextMenu = function () {
        var _this = this;
        var categories = Array.from(this.plugin.editor.nodeCategories.keys())
            .filter(function (c) { return c !== "default"; })
            .map(function (c) {
            var nodes = Array.from(_this.plugin.editor.nodeCategories.get(c))
                .map(function (n) { return ({
                value: "addNode:" + n,
                label: _this.plugin.nodeTypeAliases[n] || n
            }); });
            return { label: c, submenu: nodes };
        });
        var defaultNodes = this.plugin.editor.nodeCategories.get("default")
            .map(function (n) { return ({
            value: "addNode:" + n,
            label: _this.plugin.nodeTypeAliases[n] || n
        }); });
        var addNodeSubmenu = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spread */ "g"](categories);
        if (categories.length > 0 && defaultNodes.length > 0) {
            addNodeSubmenu.push({ isDivider: true });
        }
        addNodeSubmenu.push.apply(addNodeSubmenu, tslib__WEBPACK_IMPORTED_MODULE_0__[/* __spread */ "g"](defaultNodes));
        this.contextMenu.items = [
            {
                label: "Add Node",
                submenu: addNodeSubmenu
            },
            {
                label: "Copy Nodes",
                value: "copy",
                disabledFunction: function () { return _this.selectedNodes.length === 0; }
            },
            {
                label: "Paste Nodes",
                value: "paste",
                disabledFunction: function () { return _this.clipboard.isEmpty; }
            }
        ];
    };
    EditorView.prototype.hoveredOver = function (ni) {
        this.hoveringOver = ni;
        if (ni && this.temporaryConnection) {
            this.temporaryConnection.to = ni;
            this.temporaryConnection.status =
                this.plugin.editor.checkConnection(this.temporaryConnection.from, this.temporaryConnection.to) ?
                    _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].ALLOWED :
                    _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].FORBIDDEN;
            this.connections
                .filter(function (c) { return c.to === ni; })
                .forEach(function (c) { c.isInDanger = true; });
        }
        else if (!ni && this.temporaryConnection) {
            this.$set(this.temporaryConnection, "to", undefined);
            this.temporaryConnection.status = _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].NONE;
            this.connections.forEach(function (c) { c.isInDanger = false; });
        }
    };
    EditorView.prototype.mouseMoveHandler = function (ev) {
        if (this.temporaryConnection) {
            this.temporaryConnection.mx = (ev.offsetX / this.plugin.scaling) - this.plugin.panning.x;
            this.temporaryConnection.my = (ev.offsetY / this.plugin.scaling) - this.plugin.panning.y;
        }
        else if (this.dragging) {
            this.plugin.panning.x += ev.movementX / this.plugin.scaling;
            this.plugin.panning.y += ev.movementY / this.plugin.scaling;
        }
    };
    EditorView.prototype.mouseDown = function (ev) {
        var _this = this;
        if (ev.button === 0) {
            if (this.hoveringOver) {
                // if this interface is an input and already has a connection
                // to it, remove the connection and make it temporary
                var connection = this.connections.find(function (c) { return c.to === _this.hoveringOver; });
                if (this.hoveringOver.isInput && connection) {
                    this.temporaryConnection = {
                        status: _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].NONE,
                        from: connection.from
                    };
                    this.plugin.editor.removeConnection(connection);
                }
                else {
                    this.temporaryConnection = {
                        status: _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].NONE,
                        from: this.hoveringOver
                    };
                }
                this.$set(this.temporaryConnection, "mx", null);
                this.$set(this.temporaryConnection, "my", null);
            }
            else if (ev.target === this.$el) {
                this.unselectAllNodes();
                this.dragging = true;
            }
        }
    };
    EditorView.prototype.mouseUp = function (ev) {
        this.dragging = false;
        var tc = this.temporaryConnection;
        if (tc && this.hoveringOver) {
            this.plugin.editor.addConnection(tc.from, tc.to);
        }
        this.temporaryConnection = null;
    };
    EditorView.prototype.mouseWheel = function (ev) {
        ev.preventDefault();
        var scrollAmount = ev.deltaY;
        if (ev.deltaMode === 1) {
            scrollAmount *= 32; // Firefox fix, multiplier is trial & error
        }
        var newScale = this.plugin.scaling * (1 - scrollAmount / 3000);
        var currentPoint = [
            (ev.offsetX / this.plugin.scaling) - this.plugin.panning.x,
            (ev.offsetY / this.plugin.scaling) - this.plugin.panning.y
        ];
        var newPoint = [
            (ev.offsetX / newScale) - this.plugin.panning.x,
            (ev.offsetY / newScale) - this.plugin.panning.y
        ];
        var diff = [
            newPoint[0] - currentPoint[0],
            newPoint[1] - currentPoint[1]
        ];
        this.plugin.panning.x += diff[0];
        this.plugin.panning.y += diff[1];
        this.plugin.scaling = newScale;
    };
    EditorView.prototype.keyDown = function (ev) {
        var _this = this;
        if (ev.key === "Delete" && this.selectedNodes.length > 0) {
            this.selectedNodes.forEach(function (n) { return _this.plugin.editor.removeNode(n); });
        }
        else if (ev.key === "Tab") {
            ev.preventDefault();
        }
        else if (ev.key === "Control") {
            this.ctrlPressed = true;
        }
        else if (ev.key === "z" && ev.ctrlKey) {
            this.history.undo();
        }
        else if (ev.key === "y" && ev.ctrlKey) {
            this.history.redo();
        }
    };
    EditorView.prototype.keyUp = function (ev) {
        if (ev.key === "Control") {
            this.ctrlPressed = false;
        }
    };
    EditorView.prototype.selectNode = function (node) {
        if (!this.ctrlPressed) {
            this.unselectAllNodes();
        }
        this.selectedNodes.push(node);
    };
    EditorView.prototype.unselectAllNodes = function () {
        this.selectedNodes.splice(0, this.selectedNodes.length);
    };
    EditorView.prototype.openContextMenu = function (event) {
        this.contextMenu.show = true;
        this.contextMenu.x = event.offsetX;
        this.contextMenu.y = event.offsetY;
    };
    EditorView.prototype.onContextMenuClick = function (action) {
        if (action.startsWith("addNode:")) {
            var nodeName = action.substring(action.indexOf(":") + 1);
            var nt = this.plugin.editor.nodeTypes.get(nodeName);
            if (nt) {
                var node = this.plugin.editor.addNode(new nt());
                if (node) {
                    node.position.x = (this.contextMenu.x / this.plugin.scaling) - this.plugin.panning.x;
                    node.position.y = (this.contextMenu.y / this.plugin.scaling) - this.plugin.panning.y;
                }
            }
        }
        else if (action === "copy" && this.selectedNodes.length > 0) {
            this.clipboard.copy(this.selectedNodes);
        }
        else if (action === "paste" && !this.clipboard.isEmpty) {
            this.clipboard.paste();
        }
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Object, required: true }),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Provide */ "d"])("plugin")
    ], EditorView.prototype, "plugin", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Provide */ "d"])("editor")
    ], EditorView.prototype, "nodeeditor", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Watch */ "f"])("plugin.nodeTypeAliases")
    ], EditorView.prototype, "updateContextMenu", null);
    EditorView = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], EditorView);
    return EditorView;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (EditorView);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionView_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionView_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);



var Connection = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](Connection, _super);
    function Connection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Connection.prototype.mounted = function () {
        this.plugin.hooks.renderConnection.execute(this);
    };
    Connection.prototype.updated = function () {
        this.plugin.hooks.renderConnection.execute(this);
    };
    Object.defineProperty(Connection.prototype, "d", {
        get: function () {
            var _a = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __read */ "f"](this.transform(this.x1, this.y1), 2), tx1 = _a[0], ty1 = _a[1];
            var _b = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __read */ "f"](this.transform(this.x2, this.y2), 2), tx2 = _b[0], ty2 = _b[1];
            var dx = 0.3 * Math.abs(tx1 - tx2);
            return "M " + tx1 + " " + ty1 + " C " + (tx1 + dx) + " " + ty1 + ", " + (tx2 - dx) + " " + ty2 + ", " + tx2 + " " + ty2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Connection.prototype, "classes", {
        get: function () {
            return {
                "connection": true,
                "--temporary": this.isTemporary,
                "--allowed": this.state === _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].ALLOWED,
                "--forbidden": this.state === _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].FORBIDDEN
            };
        },
        enumerable: true,
        configurable: true
    });
    Connection.prototype.transform = function (x, y) {
        var tx = (x + this.plugin.panning.x) * this.plugin.scaling;
        var ty = (y + this.plugin.panning.y) * this.plugin.scaling;
        return [tx, ty];
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Number })
    ], Connection.prototype, "x1", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Number })
    ], Connection.prototype, "y1", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Number })
    ], Connection.prototype, "x2", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Number })
    ], Connection.prototype, "y2", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Number, default: _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_2__[/* TemporaryConnectionState */ "a"].NONE })
    ], Connection.prototype, "state", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Boolean, default: false })
    ], Connection.prototype, "isTemporary", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Object })
    ], Connection.prototype, "connection", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Inject */ "b"])("plugin")
    ], Connection.prototype, "plugin", void 0);
    Connection = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], Connection);
    return Connection;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (Connection);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionWrapper_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionWrapper_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72);
/* harmony import */ var _ConnectionView_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var _utility_domResolver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
/* harmony import */ var _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);






var ConnectionWrapper = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](ConnectionWrapper, _super);
    function ConnectionWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.d = { x1: 0, y1: 0, x2: 0, y2: 0 };
        return _this;
    }
    Object.defineProperty(ConnectionWrapper.prototype, "state", {
        get: function () {
            return this.connection.isInDanger ?
                _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_5__[/* TemporaryConnectionState */ "a"].FORBIDDEN :
                _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_5__[/* TemporaryConnectionState */ "a"].NONE;
        },
        enumerable: true,
        configurable: true
    });
    ConnectionWrapper.prototype.mounted = function () {
        return tslib__WEBPACK_IMPORTED_MODULE_0__[/* __awaiter */ "b"](this, void 0, void 0, function () {
            return tslib__WEBPACK_IMPORTED_MODULE_0__[/* __generator */ "e"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.updateCoords();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConnectionWrapper.prototype.beforeDestroy = function () {
        this.resizeObserver.disconnect();
    };
    ConnectionWrapper.prototype.updateCoords = function () {
        var _this = this;
        var from = Object(_utility_domResolver__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this.connection.from);
        var to = Object(_utility_domResolver__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this.connection.to);
        if (from.node && from.interface && to.node && to.interface) {
            if (!this.resizeObserver) {
                this.resizeObserver = new _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](function () { _this.updateCoords(); });
                this.resizeObserver.observe(from.node);
                this.resizeObserver.observe(to.node);
            }
            var x1 = from.node.offsetLeft + from.node.clientWidth;
            var y1 = from.node.offsetTop + from.interface.offsetTop + from.interface.clientHeight / 2;
            var x2 = to.node.offsetLeft;
            var y2 = to.node.offsetTop + to.interface.offsetTop + to.interface.clientHeight / 2;
            this.d = { x1: x1, y1: y1, x2: x2, y2: y2 };
        }
        else {
            this.d = { x1: 0, y1: 0, x2: 0, y2: 0 };
        }
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Object })
    ], ConnectionWrapper.prototype, "connection", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Watch */ "f"])("connection.from.parent.position", { deep: true }),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Watch */ "f"])("connection.to.parent.position", { deep: true })
    ], ConnectionWrapper.prototype, "updateCoords", null);
    ConnectionWrapper = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"])({
            components: {
                "connection-view": _ConnectionView_vue__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]
            }
        })
    ], ConnectionWrapper);
    return ConnectionWrapper;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (ConnectionWrapper);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TemporaryConnection_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TemporaryConnection_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _ConnectionView_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
/* harmony import */ var _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _utility_domResolver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);





var TemporaryConnection = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](TemporaryConnection, _super);
    function TemporaryConnection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TemporaryConnection.prototype, "status", {
        get: function () {
            return this.connection ? this.connection.status : _baklavajs_core_types__WEBPACK_IMPORTED_MODULE_3__[/* TemporaryConnectionState */ "a"].NONE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TemporaryConnection.prototype, "d", {
        get: function () {
            if (!this.connection) {
                return {
                    input: { x: 0, y: 0 },
                    output: { x: 0, y: 0 }
                };
            }
            var start = this.getCoords(this.connection.from);
            var end = this.connection.to ?
                this.getCoords(this.connection.to) :
                { x: this.connection.mx || start.x, y: this.connection.my || start.y };
            if (this.connection.from.isInput) {
                return {
                    input: end,
                    output: start
                };
            }
            else {
                return {
                    input: start,
                    output: end
                };
            }
        },
        enumerable: true,
        configurable: true
    });
    TemporaryConnection.prototype.getCoords = function (ni) {
        var d = Object(_utility_domResolver__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(ni);
        if (d.node && d.interface) {
            var x = ni.isInput ? d.node.offsetLeft : d.node.offsetLeft + d.node.clientWidth;
            var y = d.node.offsetTop + d.interface.offsetTop + d.interface.clientHeight / 2 + 2;
            return { x: x, y: y };
        }
        else {
            return { x: 0, y: 0 };
        }
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Object })
    ], TemporaryConnection.prototype, "connection", void 0);
    TemporaryConnection = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"])({
            components: {
                "connection-view": _ConnectionView_vue__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]
            }
        })
    ], TemporaryConnection);
    return TemporaryConnection;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (TemporaryConnection);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var v_click_outside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38);
/* harmony import */ var v_click_outside__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(v_click_outside__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utility_cssNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80);


// @ts-ignore


var NodeView = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](NodeView, _super);
    function NodeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dragging = false;
        _this.renaming = false;
        _this.tempName = "";
        _this.contextMenu = {
            show: false,
            x: 0,
            y: 0,
            items: [
                { value: "rename", label: "Rename" },
                { value: "delete", label: "Delete" }
            ]
        };
        _this.unsubscribe = null;
        return _this;
    }
    Object.defineProperty(NodeView.prototype, "classes", {
        get: function () {
            var _a;
            return _a = {
                    "node": true,
                    "--selected": this.selected,
                    "--dragging": this.dragging,
                    "--two-column": !!this.data.twoColumn
                },
                _a["--type-" + Object(_utility_cssNames__WEBPACK_IMPORTED_MODULE_3__[/* sanitizeName */ "a"])(this.data.type)] = true,
                _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeView.prototype, "styles", {
        get: function () {
            return {
                top: this.data.position.y + "px",
                left: this.data.position.x + "px",
                width: this.data.width + "px",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeView.prototype, "options", {
        get: function () {
            return Array.from(this.data.options.entries());
        },
        enumerable: true,
        configurable: true
    });
    NodeView.prototype.mounted = function () {
        var _this = this;
        this.data.events.addInterface.addListener(this, function () { return _this.update(); });
        this.data.events.removeInterface.addListener(this, function () { return _this.update(); });
        this.data.events.addOption.addListener(this, function () { return _this.update(); });
        this.data.events.removeOption.addListener(this, function () { return _this.update(); });
        this.plugin.hooks.renderNode.execute(this);
    };
    NodeView.prototype.updated = function () {
        this.plugin.hooks.renderNode.execute(this);
    };
    NodeView.prototype.beforeDestroy = function () {
        this.data.events.addInterface.removeListener(this);
        this.data.events.removeInterface.removeListener(this);
        this.data.events.addOption.removeListener(this);
        this.data.events.removeOption.removeListener(this);
    };
    NodeView.prototype.update = function () {
        this.$forceUpdate();
    };
    NodeView.prototype.startDrag = function () {
        this.dragging = true;
        document.addEventListener("mousemove", this.handleMove);
        document.addEventListener("mouseup", this.stopDrag);
        this.select();
    };
    NodeView.prototype.select = function () {
        this.$emit("select", this);
    };
    NodeView.prototype.stopDrag = function () {
        this.dragging = false;
        document.removeEventListener("mousemove", this.handleMove);
        document.removeEventListener("mouseup", this.stopDrag);
    };
    NodeView.prototype.handleMove = function (ev) {
        if (this.dragging) {
            this.data.position.x += ev.movementX / this.plugin.scaling;
            this.data.position.y += ev.movementY / this.plugin.scaling;
        }
    };
    NodeView.prototype.openContextMenu = function (ev) {
        this.contextMenu.show = true;
        this.contextMenu.x = ev.offsetX;
        this.contextMenu.y = ev.offsetY;
    };
    NodeView.prototype.onContextMenu = function (action) {
        switch (action) {
            case "delete":
                this.plugin.editor.removeNode(this.data);
                break;
            case "rename":
                this.tempName = this.data.name;
                this.renaming = true;
        }
    };
    NodeView.prototype.doneRenaming = function () {
        this.data.name = this.tempName;
        this.renaming = false;
    };
    NodeView.prototype.openSidebar = function (optionName) {
        this.plugin.sidebar.nodeId = this.data.id;
        this.plugin.sidebar.optionName = optionName;
        this.plugin.sidebar.visible = true;
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Object })
    ], NodeView.prototype, "data", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Boolean, default: false })
    ], NodeView.prototype, "selected", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Inject */ "b"])("plugin")
    ], NodeView.prototype, "plugin", void 0);
    NodeView = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"])({
            directives: {
                ClickOutside: v_click_outside__WEBPACK_IMPORTED_MODULE_2___default.a.directive
            }
        })
    ], NodeView);
    return NodeView;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (NodeView);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeInterface_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeInterface_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var NodeInterfaceView = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](NodeInterfaceView, _super);
    function NodeInterfaceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.isConnected = false;
        return _this;
    }
    Object.defineProperty(NodeInterfaceView.prototype, "classes", {
        get: function () {
            return {
                "node-interface": true,
                "--input": this.data.isInput,
                "--output": !this.data.isInput,
                "--connected": this.isConnected
            };
        },
        enumerable: true,
        configurable: true
    });
    NodeInterfaceView.prototype.beforeMount = function () {
        var _this = this;
        this.value = this.data.value;
        this.data.events.setValue.addListener(this, function (v) { _this.value = v; });
        this.data.events.setConnectionCount.addListener(this, function (c) {
            _this.$forceUpdate();
            _this.isConnected = c > 0;
        });
        this.isConnected = this.data.connectionCount > 0;
    };
    NodeInterfaceView.prototype.mounted = function () {
        this.plugin.hooks.renderInterface.execute(this);
    };
    NodeInterfaceView.prototype.updated = function () {
        this.plugin.hooks.renderInterface.execute(this);
    };
    NodeInterfaceView.prototype.beforeDestroy = function () {
        this.data.events.setValue.removeListener(this);
        this.data.events.setConnectionCount.removeListener(this);
    };
    NodeInterfaceView.prototype.startHover = function () {
        this.editor.hoveredOver(this.data);
    };
    NodeInterfaceView.prototype.endHover = function () {
        this.editor.hoveredOver(undefined);
    };
    NodeInterfaceView.prototype.getOptionComponent = function (name) {
        if (!name || !this.plugin.options) {
            return;
        }
        return this.plugin.options[name];
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Object, default: function () { return ({}); } })
    ], NodeInterfaceView.prototype, "data", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: String, default: "" })
    ], NodeInterfaceView.prototype, "name", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Inject */ "b"])("plugin")
    ], NodeInterfaceView.prototype, "plugin", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Inject */ "b"])("editor")
    ], NodeInterfaceView.prototype, "editor", void 0);
    NodeInterfaceView = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], NodeInterfaceView);
    return NodeInterfaceView;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (NodeInterfaceView);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var NodeOptionView = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](NodeOptionView, _super);
    function NodeOptionView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        return _this;
    }
    Object.defineProperty(NodeOptionView.prototype, "component", {
        get: function () {
            if (!this.plugin.options || !this.componentName) {
                return;
            }
            return this.plugin.options[this.componentName];
        },
        enumerable: true,
        configurable: true
    });
    NodeOptionView.prototype.beforeMount = function () {
        var _this = this;
        this.value = this.option.value;
        this.option.events.setValue.addListener(this, function (v) { _this.value = v; });
    };
    NodeOptionView.prototype.mounted = function () {
        this.plugin.hooks.renderOption.execute(this);
    };
    NodeOptionView.prototype.updated = function () {
        this.plugin.hooks.renderOption.execute(this);
    };
    NodeOptionView.prototype.beforeDestroy = function () {
        this.option.events.setValue.removeListener(this);
    };
    NodeOptionView.prototype.updateValue = function (v) {
        this.option.value = v;
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])()
    ], NodeOptionView.prototype, "name", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])()
    ], NodeOptionView.prototype, "option", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])()
    ], NodeOptionView.prototype, "componentName", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])()
    ], NodeOptionView.prototype, "node", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Inject */ "b"])("plugin")
    ], NodeOptionView.prototype, "plugin", void 0);
    NodeOptionView = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], NodeOptionView);
    return NodeOptionView;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (NodeOptionView);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var v_click_outside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38);
/* harmony import */ var v_click_outside__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(v_click_outside__WEBPACK_IMPORTED_MODULE_2__);


// @ts-ignore

var ContextMenu = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeMenu = -1;
        _this.activeMenuResetTimeout = null;
        _this.height = 0;
        _this.rootIsFlipped = { x: false, y: false };
        return _this;
    }
    ContextMenu_1 = ContextMenu;
    Object.defineProperty(ContextMenu.prototype, "styles", {
        get: function () {
            var s = {};
            if (!this.isNested) {
                s.top = (this.flippedY ? this.y - this.height : this.y) + "px";
                s.left = this.x + "px";
            }
            return s;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "classes", {
        get: function () {
            return {
                "dark-context-menu": true,
                "--flipped-x": this.flippedX,
                "--flipped-y": this.flippedY,
                "--nested": this.isNested
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "_items", {
        get: function () {
            return this.items.map(function (i) { return (tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"]({}, i, { hover: false })); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "flippedX", {
        get: function () {
            return this.flippable && (this.rootIsFlipped.x || this.isFlipped.x);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "flippedY", {
        get: function () {
            return this.flippable && (this.rootIsFlipped.y || this.isFlipped.y);
        },
        enumerable: true,
        configurable: true
    });
    ContextMenu.prototype.onClick = function (item) {
        if (!item.submenu && item.value) {
            this.$emit("click", item.value);
            this.$emit("input", false);
        }
    };
    ContextMenu.prototype.onChildClick = function (value) {
        this.$emit("click", value);
        this.activeMenu = -1;
        if (!this.isNested) {
            this.$emit("input", false);
        }
    };
    ContextMenu.prototype.onClickOutside = function (event) {
        if (this.value) {
            this.$emit("input", false);
        }
    };
    ContextMenu.prototype.onMouseEnter = function (event, index) {
        if (this.items[index].submenu) {
            this.activeMenu = index;
            if (this.activeMenuResetTimeout !== null) {
                clearTimeout(this.activeMenuResetTimeout);
                this.activeMenuResetTimeout = null;
            }
        }
    };
    ContextMenu.prototype.onMouseLeave = function (event, index) {
        var _this = this;
        if (this.items[index].submenu) {
            this.activeMenuResetTimeout = window.setTimeout(function () {
                _this.activeMenu = -1;
                _this.activeMenuResetTimeout = null;
            }, 200);
        }
    };
    ContextMenu.prototype.created = function () {
        if (this.$options.components) {
            this.$options.components["context-menu"] = vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"].extend(ContextMenu_1);
        }
        else {
            this.$options.components = { "context-menu": vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"].extend(ContextMenu_1) };
        }
    };
    ContextMenu.prototype.updateFlipped = function () {
        this.height = this.items.length * 30;
        var parentWidth = this.$parent.$el.offsetWidth;
        var parentHeight = this.$parent.$el.offsetHeight;
        this.rootIsFlipped.x = !this.isNested && this.x > (parentWidth * 0.75);
        this.rootIsFlipped.y = !this.isNested && this.y + this.height > parentHeight - 20;
    };
    ContextMenu.prototype.updateDisabledValues = function () {
        var _this = this;
        if (this.value) {
            this.items.forEach(function (item) {
                if (item.disabledFunction) {
                    _this.$set(item, "disabled", item.disabledFunction());
                }
            });
        }
    };
    var ContextMenu_1;
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Boolean, default: false })
    ], ContextMenu.prototype, "value", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Array, default: function () { return []; } })
    ], ContextMenu.prototype, "items", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Number, default: 0 })
    ], ContextMenu.prototype, "x", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Number, default: 0 })
    ], ContextMenu.prototype, "y", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Boolean, default: false })
    ], ContextMenu.prototype, "isNested", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Object, default: function () { return ({ x: false, y: false }); } })
    ], ContextMenu.prototype, "isFlipped", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Prop */ "c"])({ type: Boolean, default: false })
    ], ContextMenu.prototype, "flippable", void 0);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Watch */ "f"])("y"),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Watch */ "f"])("items")
    ], ContextMenu.prototype, "updateFlipped", null);
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Watch */ "f"])("value", { immediate: true })
    ], ContextMenu.prototype, "updateDisabledValues", null);
    ContextMenu = ContextMenu_1 = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"])({
            directives: {
                ClickOutside: v_click_outside__WEBPACK_IMPORTED_MODULE_2___default.a.directive
            }
        })
    ], ContextMenu);
    return ContextMenu;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (ContextMenu);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32);
 /* harmony default export */ __webpack_exports__["a"] = (_node_modules_ts_loader_index_js_ref_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]); 

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);


var Sidebar = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](Sidebar, _super);
    function Sidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = 300;
        return _this;
    }
    Object.defineProperty(Sidebar.prototype, "nodeName", {
        get: function () {
            var id = this.plugin.sidebar.nodeId;
            var n = this.plugin.editor.nodes.find(function (x) { return x.id === id; });
            return n ? n.name : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sidebar.prototype, "styles", {
        get: function () {
            return {
                width: this.width + "px"
            };
        },
        enumerable: true,
        configurable: true
    });
    Sidebar.prototype.close = function () {
        this.plugin.sidebar.visible = false;
    };
    Sidebar.prototype.startResize = function () {
        var _this = this;
        window.addEventListener("mousemove", this.onMouseMove);
        window.addEventListener("mouseup", function () {
            window.removeEventListener("mousemove", _this.onMouseMove);
        }, { once: true });
    };
    Sidebar.prototype.onMouseMove = function (event) {
        var maxwidth = this.$parent.$el.getBoundingClientRect().width;
        this.width -= event.movementX;
        if (this.width < 300) {
            this.width = 300;
        }
        else if (this.width > 0.9 * maxwidth) {
            this.width = 0.9 * maxwidth;
        }
    };
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Inject */ "b"])("plugin")
    ], Sidebar.prototype, "plugin", void 0);
    Sidebar = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __decorate */ "c"]([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Component */ "a"]
    ], Sidebar);
    return Sidebar;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__[/* Vue */ "e"]));
/* harmony default export */ __webpack_exports__["a"] = (Sidebar);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ConnectionWrapper_vue_vue_type_template_id_76e3acd4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48);
/* harmony import */ var _ConnectionWrapper_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _ConnectionWrapper_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _ConnectionWrapper_vue_vue_type_template_id_76e3acd4___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _ConnectionWrapper_vue_vue_type_template_id_76e3acd4___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/connection/ConnectionWrapper.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObserverBoxOptions; });
var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));



/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateDepthForNode; });
/* harmony import */ var _utils_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);

var calculateDepthForNode = function (node) {
    if (Object(_utils_element__WEBPACK_IMPORTED_MODULE_0__[/* isHidden */ "a"])(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _TemporaryConnection_vue_vue_type_template_id_3b64824e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
/* harmony import */ var _TemporaryConnection_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _TemporaryConnection_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _TemporaryConnection_vue_vue_type_template_id_3b64824e___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _TemporaryConnection_vue_vue_type_template_id_3b64824e___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/connection/TemporaryConnection.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Node_vue_vue_type_template_id_fecb42a2___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52);
/* harmony import */ var _Node_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _Node_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _Node_vue_vue_type_template_id_fecb42a2___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _Node_vue_vue_type_template_id_fecb42a2___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/node/Node.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():undefined}(this,function(){var e="undefined"!=typeof window&&("ontouchstart"in window||navigator.msMaxTouchPoints>0)?["touchstart","click"]:["click"],n=[];function t(n){var t="function"==typeof n;if(!t&&"object"!=typeof n)throw new Error("v-click-outside: Binding value must be a function or an object");return{handler:t?n:n.handler,middleware:n.middleware||function(e){return e},events:n.events||e}}function r(e){var n=e.el,t=e.event,r=e.handler,i=e.middleware;t.target!==n&&!n.contains(t.target)&&i(t,n)&&r(t,n)}var i={bind:function(e,i){var d=t(i.value),o=d.handler,a=d.middleware,u={el:e,eventHandlers:d.events.map(function(n){return{event:n,handler:function(n){return r({event:n,el:e,handler:o,middleware:a})}}})};u.eventHandlers.forEach(function(e){return document.addEventListener(e.event,e.handler)}),n.push(u)},update:function(e,i){var d=t(i.value),o=d.handler,a=d.middleware,u=d.events,c=n.find(function(n){return n.el===e});c.eventHandlers.forEach(function(e){return document.removeEventListener(e.event,e.handler)}),c.eventHandlers=u.map(function(n){return{event:n,handler:function(n){return r({event:n,el:e,handler:o,middleware:a})}}}),c.eventHandlers.forEach(function(e){return document.addEventListener(e.event,e.handler)})},unbind:function(e){n.find(function(n){return n.el===e}).eventHandlers.forEach(function(e){return document.removeEventListener(e.event,e.handler)})},instances:n};return{install:function(e){e.directive("click-outside",i)},directive:i}});
//# sourceMappingURL=v-click-outside.min.min.umd.js.map


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _NodeInterface_vue_vue_type_template_id_0871ee0c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _NodeInterface_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _NodeInterface_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _NodeInterface_vue_vue_type_template_id_0871ee0c___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _NodeInterface_vue_vue_type_template_id_0871ee0c___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/node/NodeInterface.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _NodeOption_vue_vue_type_template_id_0b61d384___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54);
/* harmony import */ var _NodeOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _NodeOption_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _NodeOption_vue_vue_type_template_id_0b61d384___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _NodeOption_vue_vue_type_template_id_0b61d384___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/node/NodeOption.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ContextMenu_vue_vue_type_template_id_2cd1f2a4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55);
/* harmony import */ var _ContextMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _ContextMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _ContextMenu_vue_vue_type_template_id_2cd1f2a4___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _ContextMenu_vue_vue_type_template_id_2cd1f2a4___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/ContextMenu.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Sidebar_vue_vue_type_template_id_7d622f5c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56);
/* harmony import */ var _Sidebar_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _Sidebar_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _Sidebar_vue_vue_type_template_id_7d622f5c___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _Sidebar_vue_vue_type_template_id_7d622f5c___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/Sidebar.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scheduler; });
/* harmony import */ var _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _prettify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);



var CATCH_FRAMES = 60 / 5;
var requestAnimationFrame = _global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].requestAnimationFrame;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var rafSlot = new Map();
var resizeObserverSlot = new Map();
var scheduled;
var dispatchCallbacksOnNextFrame = function () {
    if (scheduled) {
        return;
    }
    scheduled = true;
    function runSchedule(t) {
        scheduled = false;
        var frameCallbacks = [];
        var resizeObserverCallbacks = [];
        rafSlot.forEach(function (callback) { return frameCallbacks.push(callback); });
        resizeObserverSlot.forEach(function (callback) { return resizeObserverCallbacks.push(callback); });
        rafSlot.clear();
        resizeObserverSlot.clear();
        try {
            for (var _i = 0, frameCallbacks_1 = frameCallbacks; _i < frameCallbacks_1.length; _i++) {
                var callback = frameCallbacks_1[_i];
                callback(t);
            }
        }
        finally {
            for (var _a = 0, resizeObserverCallbacks_1 = resizeObserverCallbacks; _a < resizeObserverCallbacks_1.length; _a++) {
                var callback = resizeObserverCallbacks_1[_a];
                callback(t);
            }
        }
    }
    ;
    requestAnimationFrame(runSchedule);
};
var Scheduler = (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (frames) {
        var scheduler = this;
        resizeObserverSlot.set(this, function ResizeObserver() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = Object(_ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* process */ "b"])();
            }
            finally {
                if (elementsHaveResized) {
                    scheduler.run(60);
                }
                else if (frames) {
                    scheduler.run(frames - 1);
                }
                else {
                    scheduler.start();
                }
            }
        });
        dispatchCallbacksOnNextFrame();
    };
    Scheduler.prototype.schedule = function () {
        this.stop();
        this.run(CATCH_FRAMES);
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        document.body ? cb() : _global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            if ('MutationObserver' in _global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"]) {
                this.observer = new MutationObserver(this.listener);
                this.observe();
            }
            events.forEach(function (name) { return _global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return _global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new Scheduler();
var rafIdBase = 0;
_global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].requestAnimationFrame = function (callback) {
    if (typeof callback !== 'function') {
        throw new Error('requestAnimationFrame expects 1 callback argument of type function.');
    }
    var handle = rafIdBase += 1;
    rafSlot.set(handle, function AnimationFrame(t) { return callback(t); });
    dispatchCallbacksOnNextFrame();
    return handle;
};
_global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].cancelAnimationFrame = function (handle) {
    rafSlot.delete(handle);
};
Object(_prettify__WEBPACK_IMPORTED_MODULE_1__[/* prettifyConsoleOutput */ "b"])(_global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].requestAnimationFrame);
Object(_prettify__WEBPACK_IMPORTED_MODULE_1__[/* prettifyConsoleOutput */ "b"])(_global__WEBPACK_IMPORTED_MODULE_2__[/* global */ "a"].cancelAnimationFrame);



/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_e18b6dc6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_e18b6dc6___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_e18b6dc6___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NodeStep = /** @class */ (function () {
    function NodeStep(type, data) {
        this.type = type;
        if (type === "addNode") {
            this.nodeId = data;
        }
        else {
            this.nodeState = data;
        }
    }
    NodeStep.prototype.undo = function (editor) {
        if (this.type === "addNode") {
            this.removeNode(editor);
        }
        else {
            this.addNode(editor);
        }
    };
    NodeStep.prototype.redo = function (editor) {
        if (this.type === "addNode" && this.nodeState) {
            this.addNode(editor);
        }
        else if (this.type === "removeNode" && this.nodeId) {
            this.removeNode(editor);
        }
    };
    NodeStep.prototype.addNode = function (editor) {
        var nodeType = editor.nodeTypes.get(this.nodeState.type);
        if (!nodeType) {
            return;
        }
        var n = new nodeType();
        editor.addNode(n);
        n.load(this.nodeState);
        this.nodeId = n.id;
    };
    NodeStep.prototype.removeNode = function (editor) {
        var _this = this;
        var node = editor.nodes.find(function (n) { return n.id === _this.nodeId; });
        if (!node) {
            return;
        }
        this.nodeState = node.save();
        editor.removeNode(node);
    };
    return NodeStep;
}());
/* harmony default export */ __webpack_exports__["a"] = (NodeStep);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ConnectionStep = /** @class */ (function () {
    function ConnectionStep(type, data) {
        this.type = type;
        if (type === "addConnection") {
            this.connectionId = data;
        }
        else {
            var d = data;
            this.connectionState = {
                id: d.id,
                from: d.from.id,
                to: d.to.id
            };
        }
    }
    ConnectionStep.prototype.undo = function (editor) {
        if (this.type === "addConnection") {
            this.removeConnection(editor);
        }
        else {
            this.addConnection(editor);
        }
    };
    ConnectionStep.prototype.redo = function (editor) {
        if (this.type === "addConnection" && this.connectionState) {
            this.addConnection(editor);
        }
        else if (this.type === "removeConnection" && this.connectionId) {
            this.removeConnection(editor);
        }
    };
    ConnectionStep.prototype.addConnection = function (editor) {
        var fromIntf = editor.findNodeInterface(this.connectionState.from);
        var toIntf = editor.findNodeInterface(this.connectionState.to);
        if (!fromIntf || !toIntf) {
            return;
        }
        editor.addConnection(fromIntf, toIntf);
    };
    ConnectionStep.prototype.removeConnection = function (editor) {
        var _this = this;
        var connection = editor.connections.find(function (c) { return c.id === _this.connectionId; });
        if (!connection) {
            return;
        }
        this.connectionState = {
            id: connection.id,
            from: connection.from.id,
            to: connection.to.id
        };
        editor.removeConnection(connection);
    };
    return ConnectionStep;
}());
/* harmony default export */ __webpack_exports__["a"] = (ConnectionStep);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionView_vue_vue_type_template_id_34929434___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionView_vue_vue_type_template_id_34929434___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionView_vue_vue_type_template_id_34929434___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionWrapper_vue_vue_type_template_id_76e3acd4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionWrapper_vue_vue_type_template_id_76e3acd4___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConnectionWrapper_vue_vue_type_template_id_76e3acd4___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOMRectReadOnly; });
var DOMRectReadOnly = (function () {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return Object.freeze(this);
    }
    DOMRectReadOnly.fromRect = function (rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}());



/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gatherActiveObservationsAtDepth; });
/* harmony import */ var _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _calculateDepthForNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35);
/* harmony import */ var _calculateBoxSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);



var gatherActiveObservationsAtDepth = function (depth) {
    _calculateBoxSize__WEBPACK_IMPORTED_MODULE_2__[/* cache */ "a"].clear();
    _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* resizeObservers */ "c"].forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if (Object(_calculateDepthForNode__WEBPACK_IMPORTED_MODULE_1__[/* calculateDepthForNode */ "a"])(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};



/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TemporaryConnection_vue_vue_type_template_id_3b64824e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TemporaryConnection_vue_vue_type_template_id_3b64824e___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TemporaryConnection_vue_vue_type_template_id_3b64824e___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_template_id_fecb42a2___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_template_id_fecb42a2___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_template_id_fecb42a2___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeInterface_vue_vue_type_template_id_0871ee0c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeInterface_vue_vue_type_template_id_0871ee0c___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeInterface_vue_vue_type_template_id_0871ee0c___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeOption_vue_vue_type_template_id_0b61d384___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeOption_vue_vue_type_template_id_0b61d384___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeOption_vue_vue_type_template_id_0b61d384___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_template_id_2cd1f2a4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_template_id_2cd1f2a4___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContextMenu_vue_vue_type_template_id_2cd1f2a4___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_template_id_7d622f5c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_template_id_7d622f5c___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_template_id_7d622f5c___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "node-editor",
        {
          "ignore-mouse": !!_vm.temporaryConnection,
          "--temporary-connection": !!_vm.temporaryConnection
        }
      ],
      attrs: { tabindex: "-1" },
      on: {
        mousemove: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.mouseMoveHandler($event)
        },
        mousedown: _vm.mouseDown,
        mouseup: _vm.mouseUp,
        wheel: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.mouseWheel($event)
        },
        keydown: _vm.keyDown,
        keyup: _vm.keyUp,
        contextmenu: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          $event.preventDefault()
          return _vm.openContextMenu($event)
        }
      }
    },
    [
      _c(
        "svg",
        { staticClass: "connections-container" },
        [
          _vm._l(_vm.connections, function(connection) {
            return _c(
              "g",
              { key: connection.id },
              [
                _vm._t(
                  "connections",
                  [
                    _c(_vm.plugin.components.connection, {
                      tag: "component",
                      attrs: { connection: connection }
                    })
                  ],
                  { connection: connection }
                )
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.temporaryConnection
            ? _c(_vm.plugin.components.tempConnection, {
                tag: "component",
                attrs: { connection: _vm.temporaryConnection }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "node-container", style: _vm.styles },
        _vm._l(_vm.nodes, function(node) {
          return _c(_vm.plugin.components.node, {
            key: node.id,
            tag: "component",
            attrs: { data: node, selected: _vm.selectedNodes.includes(node) },
            on: {
              select: function($event) {
                return _vm.selectNode(node)
              }
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(_vm.plugin.components.contextMenu, {
        tag: "component",
        attrs: {
          x: _vm.contextMenu.x,
          y: _vm.contextMenu.y,
          items: _vm.contextMenu.items,
          flippable: ""
        },
        on: { click: _vm.onContextMenuClick },
        model: {
          value: _vm.contextMenu.show,
          callback: function($$v) {
            _vm.$set(_vm.contextMenu, "show", $$v)
          },
          expression: "contextMenu.show"
        }
      }),
      _vm._v(" "),
      _c(_vm.plugin.components.sidebar, { tag: "component" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemporaryConnectionState; });
var TemporaryConnectionState;
(function (TemporaryConnectionState) {
    TemporaryConnectionState[TemporaryConnectionState["NONE"] = 0] = "NONE";
    TemporaryConnectionState[TemporaryConnectionState["ALLOWED"] = 1] = "ALLOWED";
    TemporaryConnectionState[TemporaryConnectionState["FORBIDDEN"] = 2] = "FORBIDDEN";
})(TemporaryConnectionState || (TemporaryConnectionState = {}));


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", { class: _vm.classes, attrs: { d: _vm.d } })
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-view", {
    attrs: {
      x1: _vm.d.x1,
      y1: _vm.d.y1,
      x2: _vm.d.x2,
      y2: _vm.d.y2,
      state: _vm.state,
      connection: _vm.connection
    }
  })
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-view", {
    attrs: {
      x1: _vm.d.input.x,
      y1: _vm.d.input.y,
      x2: _vm.d.output.x,
      y2: _vm.d.output.y,
      state: _vm.status,
      connection: _vm.connection,
      "is-temporary": ""
    }
  })
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, style: _vm.styles, attrs: { id: _vm.data.id } },
    [
      _c(
        "div",
        {
          staticClass: "__title",
          on: {
            mousedown: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.startDrag($event)
            },
            contextmenu: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              $event.preventDefault()
              return _vm.openContextMenu($event)
            }
          }
        },
        [
          !_vm.renaming
            ? _c("span", [_vm._v(_vm._s(_vm.data.name))])
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.tempName,
                    expression: "tempName"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.doneRenaming,
                    expression: "doneRenaming"
                  }
                ],
                staticClass: "dark-input",
                attrs: { type: "text", placeholder: "Node Name" },
                domProps: { value: _vm.tempName },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.doneRenaming($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.tempName = $event.target.value
                  }
                }
              }),
          _vm._v(" "),
          _c(_vm.plugin.components.contextMenu, {
            tag: "component",
            attrs: {
              x: _vm.contextMenu.x,
              y: _vm.contextMenu.y,
              items: _vm.contextMenu.items
            },
            on: { click: _vm.onContextMenu },
            model: {
              value: _vm.contextMenu.show,
              callback: function($$v) {
                _vm.$set(_vm.contextMenu, "show", $$v)
              },
              expression: "contextMenu.show"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "__content" }, [
        _c(
          "div",
          { staticClass: "__outputs" },
          _vm._l(_vm.data.outputInterfaces, function(output, name) {
            return _c(_vm.plugin.components.nodeInterface, {
              key: output.id,
              tag: "component",
              attrs: { name: name, data: output }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "__options" },
          [
            _vm._l(_vm.options, function(ref) {
              var name = ref[0]
              var option = ref[1]
              return [
                _c(_vm.plugin.components.nodeOption, {
                  key: name,
                  tag: "component",
                  attrs: {
                    name: name,
                    option: option,
                    componentName: option.optionComponent,
                    node: _vm.data
                  },
                  on: {
                    openSidebar: function($event) {
                      return _vm.openSidebar(name)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.plugin.sidebar.nodeId === _vm.data.id &&
                _vm.plugin.sidebar.optionName === name &&
                option.sidebarComponent
                  ? _c(
                      "portal",
                      { key: "sb_" + name, attrs: { to: "sidebar" } },
                      [
                        _c(_vm.plugin.components.nodeOption, {
                          key: _vm.data.id + name,
                          tag: "component",
                          attrs: {
                            name: name,
                            option: option,
                            componentName: option.sidebarComponent,
                            node: _vm.data
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "__inputs" },
          _vm._l(_vm.data.inputInterfaces, function(input, name) {
            return _c(_vm.plugin.components.nodeInterface, {
              key: input.id,
              tag: "component",
              attrs: { name: name, data: input }
            })
          }),
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, attrs: { id: _vm.data.id } },
    [
      _c("div", {
        staticClass: "__port",
        on: { mouseover: _vm.startHover, mouseout: _vm.endHover }
      }),
      _vm._v(" "),
      _vm.data.connectionCount > 0 ||
      !_vm.data.option ||
      !_vm.getOptionComponent(_vm.data.option)
        ? _c("span", { staticClass: "align-middle" }, [
            _vm._v("\n        " + _vm._s(_vm.name) + "\n    ")
          ])
        : _c(_vm.getOptionComponent(_vm.data.option), {
            tag: "component",
            attrs: { value: _vm.value, name: _vm.name },
            on: {
              input: function($event) {
                _vm.data.value = $event
              }
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.component, {
    tag: "component",
    staticClass: "node-option",
    attrs: { name: _vm.name, node: _vm.node, value: _vm.value },
    on: {
      input: _vm.updateValue,
      openSidebar: function($event) {
        return _vm.$emit("openSidebar")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.value,
          expression: "value"
        },
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickOutside,
          expression: "onClickOutside"
        }
      ],
      class: _vm.classes,
      style: _vm.styles
    },
    [
      _vm._l(_vm._items, function(item, index) {
        return [
          item.isDivider
            ? _c("div", { key: index, staticClass: "divider" })
            : _c(
                "div",
                {
                  key: index,
                  staticClass: "d-flex align-items-center",
                  class: {
                    item: true,
                    submenu: !!item.submenu,
                    "--disabled": !!item.disabled
                  },
                  on: {
                    mouseenter: function($event) {
                      return _vm.onMouseEnter($event, index)
                    },
                    mouseleave: function($event) {
                      return _vm.onMouseLeave($event, index)
                    },
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onClick(item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "flex-fill" }, [
                    _vm._v(_vm._s(item.label))
                  ]),
                  _vm._v(" "),
                  item.submenu
                    ? _c(
                        "div",
                        {
                          staticClass: "ml-3",
                          staticStyle: { "line-height": "1em" }
                        },
                        [_vm._v("⏵")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.submenu
                    ? _c("context-menu", {
                        attrs: {
                          value: _vm.activeMenu === index,
                          items: item.submenu,
                          "is-nested": true,
                          "is-flipped": { x: _vm.flippedX, y: _vm.flippedY },
                          flippable: _vm.flippable
                        },
                        on: { click: _vm.onChildClick }
                      })
                    : _vm._e()
                ],
                1
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["sidebar", { "--open": _vm.plugin.sidebar.visible }],
      style: _vm.styles
    },
    [
      _c("div", {
        staticClass: "__resizer",
        on: { mousedown: _vm.startResize }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c(
          "button",
          {
            staticClass: "__close",
            attrs: { tabindex: "-1" },
            on: { click: _vm.close }
          },
          [_vm._v("×")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ml-2" }, [
          _c("b", [_vm._v(_vm._s(_vm.nodeName))])
        ])
      ]),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "sidebar" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaklavaVuePlugin; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Editor_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
/* harmony import */ var portal_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81);
/* harmony import */ var portal_vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(portal_vue__WEBPACK_IMPORTED_MODULE_2__);


// @ts-ignore

var Baklava = {
    install: function (Vue, args) {
        if (vue__WEBPACK_IMPORTED_MODULE_0___default.a !== Vue) {
            // tslint:disable-next-line:no-console
            console.error("Multiple instances of Vue detected\n" +
                "See https://github.com/vuetifyjs/vuetify/issues/4068\n\n" +
                'If you\'re seeing "$attrs is readonly", it\'s caused by this');
        }
        Vue.use(portal_vue__WEBPACK_IMPORTED_MODULE_2___default.a);
        Vue.component("baklava-editor", _components_Editor_vue__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);
    }
};
var BaklavaVuePlugin = Baklava;


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewPlugin; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _baklavajs_core_src_events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
/* harmony import */ var _components_node_Node_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
/* harmony import */ var _components_node_NodeOption_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40);
/* harmony import */ var _components_node_NodeInterface_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39);
/* harmony import */ var _components_connection_ConnectionWrapper_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33);
/* harmony import */ var _components_connection_TemporaryConnection_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36);
/* harmony import */ var _components_ContextMenu_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41);
/* harmony import */ var _components_Sidebar_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42);









var ViewPlugin = /** @class */ (function () {
    function ViewPlugin() {
        this.type = "ViewPlugin";
        this.panning = { x: 0, y: 0 };
        this.scaling = 1;
        this.sidebar = { visible: false, nodeId: "", optionName: "" };
        this.options = {};
        this.nodeTypeAliases = {};
        this.hooks = {
            /** Called whenever a node is rendered */
            renderNode: new _baklavajs_core_src_events__WEBPACK_IMPORTED_MODULE_1__[/* SequentialHook */ "a"](),
            /** Called whenever an option is rendered */
            renderOption: new _baklavajs_core_src_events__WEBPACK_IMPORTED_MODULE_1__[/* SequentialHook */ "a"](),
            /** Called whenever an interface is rendered */
            renderInterface: new _baklavajs_core_src_events__WEBPACK_IMPORTED_MODULE_1__[/* SequentialHook */ "a"](),
            /** Called whenever a connection is rendered */
            renderConnection: new _baklavajs_core_src_events__WEBPACK_IMPORTED_MODULE_1__[/* SequentialHook */ "a"]()
        };
        /** Use this property to provide custom components,
         * which will be used when rendering the respective entities
         */
        this.components = {
            node: _components_node_Node_vue__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"],
            nodeOption: _components_node_NodeOption_vue__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"],
            nodeInterface: _components_node_NodeInterface_vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"],
            connection: _components_connection_ConnectionWrapper_vue__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"],
            tempConnection: _components_connection_TemporaryConnection_vue__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"],
            contextMenu: _components_ContextMenu_vue__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"],
            sidebar: _components_Sidebar_vue__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]
        };
    }
    ViewPlugin.prototype.register = function (editor) {
        var _this = this;
        this.editor = editor;
        this.editor.hooks.load.tap(this, function (d) {
            _this.panning = d.panning;
            _this.scaling = d.scaling;
            return d;
        });
        this.editor.hooks.save.tap(this, function (d) {
            d.panning = _this.panning;
            d.scaling = _this.scaling;
            return d;
        });
        this.editor.events.beforeAddNode.addListener(this, function (node) {
            var n = node;
            n.position = { x: 0, y: 0 };
            n.disablePointerEvents = false;
            n.twoColumn = n.twoColumn || false;
            n.width = n.width || 200;
            node.hooks.save.tap(_this, function (state) {
                state.position = n.position;
                state.width = n.width;
                state.twoColumn = n.twoColumn;
                return state;
            });
            node.hooks.load.tap(_this, function (state) {
                // default values for savefiles from older versions
                n.position = state.position || { x: 0, y: 0 };
                n.width = state.width || 200;
                n.twoColumn = state.twoColumn || false;
                return state;
            });
        });
    };
    /**
     * Register a node option
     * @param name Name of the node option as used when defining nodes
     * @param component Component that will be rendered for the option
     */
    ViewPlugin.prototype.registerOption = function (name, component) {
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.set(this.options, name, component);
    };
    /**
     * Add an alias for a node type that is displayed in the "Add Node" context menu instead of
     * the raw node type name
     * @param nodeType Node type
     * @param alias Alias that will be displayed in the context menu. When this value is `null`, an existing alias is removed
     */
    ViewPlugin.prototype.setNodeTypeAlias = function (nodeType, alias) {
        if (alias) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.set(this.nodeTypeAliases, nodeType, alias);
        }
        else if (this.nodeTypeAliases[nodeType]) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.delete(this.nodeTypeAliases, nodeType);
        }
    };
    return ViewPlugin;
}());



/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BaklavaEvent */
/* unused harmony export PreventableBaklavaEvent */
/* unused harmony export Hook */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SequentialHook; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);

/** Main event class for Baklava */
var BaklavaEvent = /** @class */ (function () {
    function BaklavaEvent() {
        this.listeners = new Map();
    }
    /**
     * Subscribe to the event
     * @param token A token that can be used to unsubscribe from the event later on
     * @param listener A callback that will be invoked when the event occurs
     */
    BaklavaEvent.prototype.addListener = function (token, listener) {
        this.listeners.set(token, listener);
    };
    /**
     * Remove a listener
     * @param token The token that was specified when subscribing to the listener.
     * An invalid token does not result in an error.
     */
    BaklavaEvent.prototype.removeListener = function (token) {
        if (this.listeners.has(token)) {
            this.listeners.delete(token);
        }
    };
    /**
     * Invoke all listeners
     * @param data The data to invoke the listeners with.
     */
    BaklavaEvent.prototype.emit = function (data) {
        this.listeners.forEach(function (l) { return l(data); });
    };
    return BaklavaEvent;
}());

/** Extension for the [[BaklavaEvent]] class. A listener can return `false` to prevent
 * this event from happening.
 */
var PreventableBaklavaEvent = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](PreventableBaklavaEvent, _super);
    function PreventableBaklavaEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Invoke all listeners.
     * @param data The data to invoke all listeners with
     * @returns `true` when one of the listeners requested to prevent the event, otherwise `false`
     */
    PreventableBaklavaEvent.prototype.emit = function (data) {
        var e_1, _a;
        try {
            for (var _b = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __values */ "h"](Array.from(this.listeners.values())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var l = _c.value;
                if (l(data) === false) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    return PreventableBaklavaEvent;
}(BaklavaEvent));

/** Base class for hooks in Baklava */
var Hook = /** @class */ (function () {
    function Hook() {
        this.tapMap = new Map();
        this.taps = [];
    }
    Hook.prototype.tap = function (token, tapFn) {
        if (this.tapMap.has(token)) {
            this.untap(token);
        }
        this.tapMap.set(token, tapFn);
        this.taps.push(tapFn);
    };
    Hook.prototype.untap = function (token) {
        if (this.tapMap.has(token)) {
            var tapFn = this.tapMap.get(token);
            this.tapMap.delete(token);
            var i = this.taps.indexOf(tapFn);
            if (i >= 0) {
                this.taps.splice(i, 1);
            }
        }
    };
    return Hook;
}());

/** This class will run the taps one after each other and pass the data from every tap to another. */
var SequentialHook = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "d"](SequentialHook, _super);
    function SequentialHook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SequentialHook.prototype.execute = function (data) {
        var e_2, _a;
        var currentValue = data;
        try {
            for (var _b = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __values */ "h"](this.taps), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tapFn = _c.value;
                currentValue = tapFn(currentValue);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return currentValue;
    };
    return SequentialHook;
}(Hook));



/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);

var Clipboard = /** @class */ (function () {
    function Clipboard(editor) {
        this.nodeBuffer = "";
        this.connectionBuffer = "";
        this.editor = editor;
    }
    Object.defineProperty(Clipboard.prototype, "isEmpty", {
        get: function () {
            return !this.nodeBuffer;
        },
        enumerable: true,
        configurable: true
    });
    Clipboard.prototype.clear = function () {
        this.nodeBuffer = "";
        this.connectionBuffer = "";
    };
    Clipboard.prototype.copy = function (selectedNodes) {
        this.connectionBuffer = JSON.stringify(this.editor.connections
            .filter(function (conn) { return selectedNodes.includes(conn.from.parent) && selectedNodes.includes(conn.to.parent); })
            .map(function (conn) { return ({ from: conn.from.id, to: conn.to.id }); }));
        this.nodeBuffer = JSON.stringify(selectedNodes.map(function (n) { return n.save(); }));
    };
    Clipboard.prototype.paste = function () {
        var _this = this;
        var e_1, _a, e_2, _b;
        // Map old IDs to new IDs
        var idmap = new Map();
        // TODO: What is this?
        var intfmap = new Map();
        var parsedNodeBuffer = JSON.parse(this.nodeBuffer);
        var parsedConnectionBuffer = JSON.parse(this.connectionBuffer);
        var _loop_1 = function (n) {
            var nodeType = this_1.editor.nodeTypes.get(n.type);
            if (!nodeType) {
                // tslint:disable-next-line: no-console
                console.warn("Node type " + n.type + " not registered");
                return { value: void 0 };
            }
            var copiedNode = new nodeType();
            var generatedId = copiedNode.id;
            copiedNode.interfaces.forEach(function (intf) {
                intf.hooks.load.tap(_this, function (intfState) {
                    var newIntfId = _this.editor.generateId("ni");
                    idmap.set(intfState.id, newIntfId);
                    intfmap.set(intfState.id, generatedId);
                    intf.id = newIntfId;
                    intf.hooks.load.untap(_this);
                    return intfState;
                });
            });
            copiedNode.hooks.load.tap(this_1, function (nodeState) {
                var ns = nodeState;
                if (ns.position) {
                    ns.position.x += 10;
                    ns.position.y += 10;
                }
                return ns;
            });
            this_1.editor.addNode(copiedNode);
            copiedNode.load(n);
            copiedNode.id = generatedId;
            idmap.set(n.id, generatedId);
        };
        var this_1 = this;
        try {
            for (var parsedNodeBuffer_1 = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __values */ "h"](parsedNodeBuffer), parsedNodeBuffer_1_1 = parsedNodeBuffer_1.next(); !parsedNodeBuffer_1_1.done; parsedNodeBuffer_1_1 = parsedNodeBuffer_1.next()) {
                var n = parsedNodeBuffer_1_1.value;
                var state_1 = _loop_1(n);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (parsedNodeBuffer_1_1 && !parsedNodeBuffer_1_1.done && (_a = parsedNodeBuffer_1.return)) _a.call(parsedNodeBuffer_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var _loop_2 = function (c) {
            var fromNode = this_2.editor.nodes.find(function (n) { return n.id === intfmap.get(c.from); });
            var toNode = this_2.editor.nodes.find(function (n) { return n.id === intfmap.get(c.to); });
            if (!fromNode || !toNode) {
                return "continue";
            }
            var fromIntf = Array.from(fromNode.interfaces.values()).find(function (intf) { return intf.id === idmap.get(c.from); });
            var toIntf = Array.from(toNode.interfaces.values()).find(function (intf) { return intf.id === idmap.get(c.to); });
            if (!fromIntf || !toIntf) {
                return "continue";
            }
            this_2.editor.addConnection(fromIntf, toIntf);
        };
        var this_2 = this;
        try {
            for (var parsedConnectionBuffer_1 = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __values */ "h"](parsedConnectionBuffer), parsedConnectionBuffer_1_1 = parsedConnectionBuffer_1.next(); !parsedConnectionBuffer_1_1.done; parsedConnectionBuffer_1_1 = parsedConnectionBuffer_1.next()) {
                var c = parsedConnectionBuffer_1_1.value;
                _loop_2(c);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (parsedConnectionBuffer_1_1 && !parsedConnectionBuffer_1_1.done && (_b = parsedConnectionBuffer_1.return)) _b.call(parsedConnectionBuffer_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    return Clipboard;
}());
/* harmony default export */ __webpack_exports__["a"] = (Clipboard);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _nodeStep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _connectionStep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46);


var History = /** @class */ (function () {
    function History(viewPlugin) {
        var _this = this;
        this.maxSteps = 200;
        this.steps = [];
        this.changeBySelf = false;
        this.currentIndex = -1;
        this.activeTransaction = false;
        this.transactionSteps = [];
        this.viewPlugin = viewPlugin;
        this.viewPlugin.editor.events.addNode.addListener(this, function (node) {
            _this.addStep(new _nodeStep__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]("addNode", node.id));
        });
        this.viewPlugin.editor.events.removeNode.addListener(this, function (node) {
            _this.addStep(new _nodeStep__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]("removeNode", node.save()));
        });
        this.viewPlugin.editor.events.addConnection.addListener(this, function (conn) {
            _this.addStep(new _connectionStep__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]("addConnection", conn.id));
        });
        this.viewPlugin.editor.events.removeConnection.addListener(this, function (conn) {
            _this.addStep(new _connectionStep__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]("removeConnection", conn));
        });
    }
    History.prototype.startTransaction = function () {
        this.activeTransaction = true;
    };
    History.prototype.commitTransaction = function () {
        this.activeTransaction = false;
    };
    History.prototype.undo = function () {
        if (this.steps.length === 0 || this.currentIndex === -1) {
            return;
        }
        this.changeBySelf = true;
        this.steps[this.currentIndex--].undo(this.viewPlugin.editor);
        this.changeBySelf = false;
    };
    History.prototype.redo = function () {
        if (this.steps.length === 0 || this.currentIndex >= this.steps.length - 1) {
            return;
        }
        this.changeBySelf = true;
        this.steps[++this.currentIndex].redo(this.viewPlugin.editor);
        this.changeBySelf = false;
    };
    History.prototype.addStep = function (step) {
        if (this.changeBySelf) {
            return;
        }
        if (this.activeTransaction) {
            this.transactionSteps.push(step);
        }
        else {
            if (this.currentIndex !== this.steps.length - 1) {
                this.steps = this.steps.slice(0, this.currentIndex + 1);
            }
            this.steps.push(step);
            this.currentIndex++;
            while (this.steps.length > this.maxSteps) {
                this.steps.shift();
            }
        }
    };
    return History;
}());
/* harmony default export */ __webpack_exports__["a"] = (History);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ResizeObserver */
/* harmony import */ var _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _utils_prettify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);


var ResizeObserver = (function () {
    function ResizeObserver(callback) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (typeof callback !== 'function') {
            throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        }
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* ResizeObserverController */ "a"].connect(this, callback);
    }
    ResizeObserver.prototype.observe = function (target, options) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (target instanceof Element === false) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* ResizeObserverController */ "a"].observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (target instanceof Element === false) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* ResizeObserverController */ "a"].unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function () {
        _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* ResizeObserverController */ "a"].disconnect(this);
    };
    ResizeObserver.toString = function () {
        return _utils_prettify__WEBPACK_IMPORTED_MODULE_1__[/* POLYFILL_CONSOLE_OUTPUT */ "a"];
    };
    return ResizeObserver;
}());
/* harmony default export */ __webpack_exports__["a"] = (ResizeObserver);



/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObservation; });
/* harmony import */ var _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);
/* harmony import */ var _algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var _utils_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);



var skipNotifyOnElement = function (target) {
    return !Object(_utils_element__WEBPACK_IMPORTED_MODULE_2__[/* isSVG */ "c"])(target)
        && !Object(_utils_element__WEBPACK_IMPORTED_MODULE_2__[/* isReplacedElement */ "b"])(target)
        && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = (function () {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || _ResizeObserverBoxOptions__WEBPACK_IMPORTED_MODULE_0__[/* ResizeObserverBoxOptions */ "a"].CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function () {
        var size = Object(_algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_1__[/* calculateBoxSize */ "b"])(this.target, this.observedBox);
        if (skipNotifyOnElement(this.target)) {
            this.lastReportedSize = size;
        }
        if (this.lastReportedSize.inlineSize !== size.inlineSize
            || this.lastReportedSize.blockSize !== size.blockSize) {
            return true;
        }
        return false;
    };
    return ResizeObservation;
}());



/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObserverDetail; });
var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());



/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasActiveObservations; });
/* harmony import */ var _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);

var hasActiveObservations = function () {
    return _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* resizeObservers */ "c"].some(function (ro) { return ro.activeTargets.length > 0; });
};



/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasSkippedObservations; });
/* harmony import */ var _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);

var hasSkippedObservations = function () {
    return _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* resizeObservers */ "c"].some(function (ro) { return ro.skippedTargets.length > 0; });
};



/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deliverResizeLoopError; });
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function () {
    var event;
    if (typeof ErrorEvent === 'function') {
        event = new ErrorEvent('error', {
            message: msg
        });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};



/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return broadcastActiveObservations; });
/* harmony import */ var _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _ResizeObserverEntry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79);
/* harmony import */ var _calculateDepthForNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35);
/* harmony import */ var _calculateBoxSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);




var broadcastActiveObservations = function () {
    var shallowestDepth = Infinity;
    var callbacks = [];
    _ResizeObserverController__WEBPACK_IMPORTED_MODULE_0__[/* resizeObservers */ "c"].forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new _ResizeObserverEntry__WEBPACK_IMPORTED_MODULE_1__[/* ResizeObserverEntry */ "a"](ot.target);
            var targetDepth = Object(_calculateDepthForNode__WEBPACK_IMPORTED_MODULE_2__[/* calculateDepthForNode */ "a"])(ot.target);
            entries.push(entry);
            ot.lastReportedSize = Object(_calculateBoxSize__WEBPACK_IMPORTED_MODULE_3__[/* calculateBoxSize */ "b"])(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};



/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObserverEntry; });
/* harmony import */ var _algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);

var ResizeObserverEntry = (function () {
    function ResizeObserverEntry(target) {
        var boxes = Object(_algorithms_calculateBoxSize__WEBPACK_IMPORTED_MODULE_0__[/* calculateBoxSizes */ "c"])(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = boxes.borderBoxSize;
        this.contentBoxSize = boxes.contentBoxSize;
    }
    return ResizeObserverEntry;
}());



/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sanitizeName; });
function sanitizeName(name) {
    return name.replace(" ", "-");
}


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/*
    portal-vue
    Version: 1.5.1
    Licence: MIT
    (c) Thorsten Lünborg
  */
  
(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(6)) :
	undefined;
}(this, (function (Vue) { 'use strict';

Vue = Vue && Vue.hasOwnProperty('default') ? Vue['default'] : Vue;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function extractAttributes(el) {
  var map = el.hasAttributes() ? el.attributes : [];
  var attrs = {};
  for (var i = 0; i < map.length; i++) {
    var attr = map[i];
    if (attr.value) {
      attrs[attr.name] = attr.value === '' ? true : attr.value;
    }
  }
  var klass = void 0,
      style = void 0;
  if (attrs.class) {
    klass = attrs.class;
    delete attrs.class;
  }
  if (attrs.style) {
    style = attrs.style;
    delete attrs.style;
  }
  var data = {
    attrs: attrs,
    class: klass,
    style: style
  };
  return data;
}

function freeze(item) {
  if (Array.isArray(item) || (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
    return Object.freeze(item);
  }
  return item;
}

function combinePassengers(transports) {
  var slotProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return transports.reduce(function (passengers, transport) {
    var newPassengers = transport.passengers[0];
    newPassengers = typeof newPassengers === 'function' ? newPassengers(slotProps) : transport.passengers;
    return passengers.concat(newPassengers);
  }, []);
}

function stableSort(array, compareFn) {
  return array.map(function (v, idx) {
    return [idx, v];
  }).sort(function (a, b) {
    return this(a[1], b[1]) || a[0] - b[0];
  }.bind(compareFn)).map(function (c) {
    return c[1];
  });
}

var transports = {};

var Wormhole = Vue.extend({
  data: function data() {
    return { transports: transports };
  },
  methods: {
    open: function open(transport) {
      var to = transport.to,
          from = transport.from,
          passengers = transport.passengers;

      if (!to || !from || !passengers) return;

      transport.passengers = freeze(passengers);
      var keys = Object.keys(this.transports);
      if (keys.indexOf(to) === -1) {
        Vue.set(this.transports, to, []);
      }

      var currentIndex = this.getTransportIndex(transport);
      // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
      var newTransports = this.transports[to].slice(0);
      if (currentIndex === -1) {
        newTransports.push(transport);
      } else {
        newTransports[currentIndex] = transport;
      }
      this.transports[to] = stableSort(newTransports, function (a, b) {
        return a.order - b.order;
      });
    },
    close: function close(transport) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var to = transport.to,
          from = transport.from;

      if (!to || !from) return;
      if (!this.transports[to]) {
        return;
      }

      if (force) {
        this.transports[to] = [];
      } else {
        var index = this.getTransportIndex(transport);
        if (index >= 0) {
          // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
          var newTransports = this.transports[to].slice(0);
          newTransports.splice(index, 1);
          this.transports[to] = newTransports;
        }
      }
    },
    hasTarget: function hasTarget(to) {
      return this.transports.hasOwnProperty(to);
    },
    hasContentFor: function hasContentFor(to) {
      if (!this.transports[to]) {
        return false;
      }
      return this.getContentFor(to).length > 0;
    },
    getSourceFor: function getSourceFor(to) {
      return this.transports[to] && this.transports[to][0].from;
    },
    getContentFor: function getContentFor(to) {
      var transports = this.transports[to];
      if (!transports) {
        return undefined;
      }
      return combinePassengers(transports);
    },
    getTransportIndex: function getTransportIndex(_ref) {
      var to = _ref.to,
          from = _ref.from;

      for (var i in this.transports[to]) {
        if (this.transports[to][i].from === from) {
          return i;
        }
      }
      return -1;
    }
  }
});

var wormhole = new Wormhole(transports);

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/;

var babelHelperVueJsxMergeProps = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp;
    for (key in b) {
      aa = a[key];
      bb = b[key];
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa;
            a[key] = aa = {};
            aa[temp] = true;
          }
          if (typeof bb === 'string') {
            temp = bb;
            b[key] = bb = {};
            bb[temp] = true;
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey]);
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb);
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb);
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey];
          }
        }
      } else {
        a[key] = b[key];
      }
    }
    return a
  }, {})
};

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments);
    b && b.apply(this, arguments);
  }
}

// import { transports } from './wormhole'
var PortalTarget = {
  abstract: false,
  name: 'portalTarget',
  props: {
    attributes: { type: Object, default: function _default() {
        return {};
      } },
    multiple: { type: Boolean, default: false },
    name: { type: String, required: true },
    slim: { type: Boolean, default: false },
    slotProps: { type: Object, default: function _default() {
        return {};
      } },
    tag: { type: String, default: 'div' },
    transition: { type: [Boolean, String, Object], default: false },
    transitionEvents: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      transports: wormhole.transports,
      firstRender: true
    };
  },
  created: function created() {
    if (!this.transports[this.name]) {
      this.$set(this.transports, this.name, []);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.unwatch = this.$watch('ownTransports', this.emitChange);
    this.$nextTick(function () {
      if (_this.transition) {
        // only when we have a transition, because it causes a re-render
        _this.firstRender = false;
      }
    });
    if (this.$options.abstract) {
      this.$options.abstract = false;
    }
  },
  updated: function updated() {
    if (this.$options.abstract) {
      this.$options.abstract = false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unwatch();
  },


  computed: {
    ownTransports: function ownTransports() {
      var transports$$1 = this.transports[this.name] || [];
      if (this.multiple) {
        return transports$$1;
      }
      return transports$$1.length === 0 ? [] : [transports$$1[transports$$1.length - 1]];
    },
    passengers: function passengers() {
      return combinePassengers(this.ownTransports, this.slotProps);
    },
    hasAttributes: function hasAttributes() {
      return Object.keys(this.attributes).length > 0;
    },
    withTransition: function withTransition() {
      return !!this.transition;
    },
    transitionData: function transitionData() {
      var t = this.transition;
      var data = {};

      // During first render, we render a dumb transition without any classes, events and a fake name
      // We have to do this to emulate the normal behaviour of transitions without `appear`
      // because in Portals, transitions can behave as if appear was defined under certain conditions.
      if (this.firstRender && _typeof(this.transition) === 'object' && !this.transition.appear) {
        data.props = { name: '__notranstition__portal-vue__' };
        return data;
      }

      if (typeof t === 'string') {
        data.props = { name: t };
      } else if ((typeof t === 'undefined' ? 'undefined' : _typeof(t)) === 'object') {
        data.props = t;
      }
      if (this.renderSlim) {
        data.props.tag = this.tag;
      }
      data.on = this.transitionEvents;

      return data;
    },
    transportedClasses: function transportedClasses() {
      return this.ownTransports.map(function (transport) {
        return transport.class;
      }).reduce(function (array, subarray) {
        return array.concat(subarray);
      }, []);
      //.filter((string, index, array) => array.indexOf(string) === index)
    }
  },

  methods: {
    emitChange: function emitChange(newTransports, oldTransports) {
      if (this.multiple) {
        this.$emit('change', [].concat(toConsumableArray(newTransports)), [].concat(toConsumableArray(oldTransports)));
      } else {
        var newTransport = newTransports.length === 0 ? undefined : newTransports[0];
        var oldTransport = oldTransports.length === 0 ? undefined : oldTransports[0];
        this.$emit('change', _extends({}, newTransport), _extends({}, oldTransport));
      }
    },

    // can't be a computed prop because it has to "react" to $slot changes.
    children: function children() {
      return this.passengers.length !== 0 ? this.passengers : this.$slots.default || [];
    },
    noWrapper: function noWrapper() {
      var noWrapper = !this.hasAttributes && this.slim;
      if (noWrapper && this.children().length > 1) {
        console.warn('[portal-vue]: PortalTarget with `slim` option received more than one child element.');
      }
      return noWrapper;
    }
  },
  render: function render(h) {
    this.$options.abstract = true;
    var noWrapper = this.noWrapper();
    var children = this.children();
    var TransitionType = noWrapper ? 'transition' : 'transition-group';
    var Tag = this.tag;

    if (this.withTransition) {
      return h(
        TransitionType,
        babelHelperVueJsxMergeProps([this.transitionData, { 'class': 'vue-portal-target' }]),
        [children]
      );
    }

    return noWrapper ? children[0] : h(
      Tag,
      babelHelperVueJsxMergeProps([{
        'class': 'vue-portal-target ' + this.transportedClasses.join(' ')
      }, this.attributes]),
      [children]
    );
  }
};

var inBrowser = typeof window !== 'undefined';

var pid = 1;

var Portal = {
  abstract: false,
  name: 'portal',
  props: {
    /* global HTMLElement */
    disabled: { type: Boolean, default: false },
    name: { type: String, default: function _default() {
        return String(pid++);
      } },
    order: { type: Number, default: 0 },
    slim: { type: Boolean, default: false },
    slotProps: { type: Object, default: function _default() {
        return {};
      } },
    tag: { type: [String], default: 'DIV' },
    targetEl: { type: inBrowser ? [String, HTMLElement] : String },
    targetClass: { type: String },
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    }
  },

  mounted: function mounted() {
    if (this.targetEl) {
      this.mountToTarget();
    }
    if (!this.disabled) {
      this.sendUpdate();
    }
    // Reset hack to make child components skip the portal when defining their $parent
    // was set to true during render when we render something locally.
    if (this.$options.abstract) {
      this.$options.abstract = false;
    }
  },
  updated: function updated() {
    if (this.disabled) {
      this.clear();
    } else {
      this.sendUpdate();
    }
    // Reset hack to make child components skip the portal when defining their $parent
    // was set to true during render when we render something locally.
    if (this.$options.abstract) {
      this.$options.abstract = false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clear();
    if (this.mountedComp) {
      this.mountedComp.$destroy();
    }
  },

  watch: {
    to: function to(newValue, oldValue) {
      oldValue && oldValue !== newValue && this.clear(oldValue);
      this.sendUpdate();
    },
    targetEl: function targetEl(newValue, oldValue) {
      if (newValue) {
        this.mountToTarget();
      }
    }
  },

  methods: {
    normalizedSlots: function normalizedSlots() {
      return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
    },
    sendUpdate: function sendUpdate() {
      var slotContent = this.normalizedSlots();

      if (slotContent) {
        wormhole.open({
          from: this.name,
          to: this.to,
          passengers: [].concat(toConsumableArray(slotContent)),
          class: this.targetClass && this.targetClass.split(' '),
          order: this.order
        });
      } else {
        this.clear();
      }
    },
    clear: function clear(target) {
      wormhole.close({
        from: this.name,
        to: target || this.to
      });
    },
    mountToTarget: function mountToTarget() {
      var el = void 0;
      var target = this.targetEl;

      if (typeof target === 'string') {
        el = document.querySelector(target);
      } else if (target instanceof HTMLElement) {
        el = target;
      } else {
        console.warn('[vue-portal]: value of targetEl must be of type String or HTMLElement');
        return;
      }

      if (el) {
        var newTarget = new Vue(_extends({}, PortalTarget, {
          parent: this,
          propsData: {
            name: this.to,
            tag: el.tagName,
            attributes: extractAttributes(el)
          }
        }));
        newTarget.$mount(el);
        this.mountedComp = newTarget;
      } else {
        console.warn('[vue-portal]: The specified targetEl ' + target + ' was not found');
      }
    },
    normalizeChildren: function normalizeChildren(children) {
      return typeof children === 'function' ? children(this.slotProps) : children;
    }
  },

  render: function render(h) {
    var children = this.$slots.default || this.$scopedSlots.default || [];
    var Tag = this.tag;
    if (children.length && this.disabled) {
      // hack to make child components skip the portal when defining their $parent
      this.$options.abstract = true;
      return children.length <= 1 && this.slim ? children[0] : h(Tag, [this.normalizeChildren(children)]);
    } else {
      return h(Tag, {
        'class': 'v-portal',
        style: 'display: none',
        key: 'v-portal-placeholder'
      });
      // h(this.tag, { class: { 'v-portal': true }, style: { display: 'none' }, key: 'v-portal-placeholder' })
    }
  }
};

function install(Vue$$1) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue$$1.component(opts.portalName || 'Portal', Portal);
  Vue$$1.component(opts.portalTargetName || 'PortalTarget', PortalTarget);
}
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use({ install: install });
}

var index = {
  install: install,
  Portal: Portal,
  PortalTarget: PortalTarget,
  Wormhole: wormhole
};

return index;

})));
//# sourceMappingURL=portal-vue.js.map


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Components", function() { return Components; });
/* harmony import */ var _components_Editor_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _components_Editor_vue__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _components_connection_ConnectionView_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10);
/* harmony import */ var _components_connection_ConnectionWrapper_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33);
/* harmony import */ var _components_connection_TemporaryConnection_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36);
/* harmony import */ var _components_node_Node_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37);
/* harmony import */ var _components_node_NodeInterface_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39);
/* harmony import */ var _components_node_NodeOption_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40);
/* harmony import */ var _components_ContextMenu_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41);
/* harmony import */ var _components_Sidebar_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42);
/* harmony import */ var _baklavaVuePlugin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaklavaVuePlugin", function() { return _baklavaVuePlugin__WEBPACK_IMPORTED_MODULE_9__["a"]; });

/* harmony import */ var _viewPlugin__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ViewPlugin", function() { return _viewPlugin__WEBPACK_IMPORTED_MODULE_10__["a"]; });










var Components = {
    Connection: _components_connection_ConnectionView_vue__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], ConnectionWrapper: _components_connection_ConnectionWrapper_vue__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], TemporaryConnection: _components_connection_TemporaryConnection_vue__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"],
    Node: _components_node_Node_vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], NodeInterface: _components_node_NodeInterface_vue__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], NodeOption: _components_node_NodeOption_vue__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"],
    ContextMenu: _components_ContextMenu_vue__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], Sidebar: _components_Sidebar_vue__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]
};




/***/ })
/******/ ]);
});